import React, { useCallback } from 'react'
import { type DataGridTypes } from 'devextreme-react/data-grid'
import { getIconClass } from 'helpers/get-icon-class'

export const useIxIconCellRender = ({ iconsMap, dataField }: any) => {
    const cellRender = useCallback((props: DataGridTypes.ColumnCellTemplateData) => {
        if (!iconsMap || iconsMap.length === 0) {
            return props.text
        }

        const enumValue = dataField ? props.data[dataField] : props.value;

        const iconName = iconsMap[enumValue] ? iconsMap[enumValue].icon || iconsMap[enumValue] : null;
        const iconColor = iconsMap[enumValue] ? iconsMap[enumValue].color : null;

        return (
            <div style={ { display: 'flex', alignItems: 'center' } }>
                {
                    iconName ? (
                        <i className={`ix-cell-icon ${getIconClass(iconName)}`} style={{ color: iconColor } } />
                    ) : null
                }
                { props.text }
            </div>
        )
    }, [iconsMap, dataField])

    return cellRender
}

export const useIxLookupCellRender = ({ lookupMap }: any) => {
    const cellRender = useCallback((props: DataGridTypes.ColumnCellTemplateData) => {
        const selectionMode: any = props.component.option('selection')?.mode || 'single'
        const value = props.value

        let _value = ''
        let iconDef = null

        if (selectionMode === 'range' || selectionMode === 'multicsv') {
            _value = value
        } else if (selectionMode === 'multi') {
            _value = JSON.parse(value)?.map((id: any) => lookupMap.find((user: any) => id === user.id)?.value).join(', ')
        } else {
            if (lookupMap) {
                const item = lookupMap.find((item: any) => Number(value) === item.id)
                if (item) {
                    _value = item.value
                    iconDef = item.icon || null
                }
            } else {
                _value = value
            }
        }

        return (
            <div style={ { display: 'flex', alignItems: 'center' } }>
                {
                    iconDef ? (
                        <i className={`ix-cell-icon ${getIconClass(iconDef.icon)}`} style={{ color: iconDef.color } } />
                    ) : null
                }
                { _value }
            </div>
        )
    }, [lookupMap])

    return cellRender
}
